import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enableHover", "imageHeight", "imageWidth", "showDiscount", "showDiscountOnlyCashInfo", "showInCashLabel", "attributeStyle", "colorMinLength", "isSellerPage", "isSlider", "displayMode", "auto", "showControls", "slidesPerView", "showPartialNextSlide", "showArrowControls", "showRating", "interval", "transitionDuration", "gutter", "productTitleAs", "imageAltPrefix", "imgLazyLoading", "cardType", "showBorder", "showOfferTimer", "showButton", "buttonProps", "hideOriginalPrice"];
import React from 'react';
import { bool, string, number, shape } from 'prop-types';
import ProductCarouselModule from '@magalu/stereo-ui/organisms/ProductCarousel';
import isServiceType from '../../../commons/isServiceType';
import withLayoutProps from '../../../hocs/withLayoutProps';
import useProductList from '../ProductList/useProductList';
var offerTimerProps = {
  bg: 'primary'
};
var ProductCarousel = function ProductCarousel(_ref) {
  var _structure$theme;
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$enableHo = _ref$static2.enableHover,
    enableHover = _ref$static2$enableHo === void 0 ? false : _ref$static2$enableHo,
    imageHeight = _ref$static2.imageHeight,
    imageWidth = _ref$static2.imageWidth,
    showDiscount = _ref$static2.showDiscount,
    showDiscountOnlyCashInfo = _ref$static2.showDiscountOnlyCashInfo,
    _ref$static2$showInCa = _ref$static2.showInCashLabel,
    showInCashLabel = _ref$static2$showInCa === void 0 ? true : _ref$static2$showInCa,
    attributeStyle = _ref$static2.attributeStyle,
    colorMinLength = _ref$static2.colorMinLength,
    _ref$static2$isSeller = _ref$static2.isSellerPage,
    isSellerPage = _ref$static2$isSeller === void 0 ? false : _ref$static2$isSeller,
    _ref$static2$isSlider = _ref$static2.isSlider,
    isSlider = _ref$static2$isSlider === void 0 ? false : _ref$static2$isSlider,
    _ref$static2$displayM = _ref$static2.displayMode,
    displayMode = _ref$static2$displayM === void 0 ? 'gallery' : _ref$static2$displayM,
    _ref$static2$auto = _ref$static2.auto,
    auto = _ref$static2$auto === void 0 ? false : _ref$static2$auto,
    _ref$static2$showCont = _ref$static2.showControls,
    showControls = _ref$static2$showCont === void 0 ? false : _ref$static2$showCont,
    _ref$static2$slidesPe = _ref$static2.slidesPerView,
    slidesPerView = _ref$static2$slidesPe === void 0 ? 5 : _ref$static2$slidesPe,
    _ref$static2$showPart = _ref$static2.showPartialNextSlide,
    showPartialNextSlide = _ref$static2$showPart === void 0 ? false : _ref$static2$showPart,
    _ref$static2$showArro = _ref$static2.showArrowControls,
    showArrowControls = _ref$static2$showArro === void 0 ? true : _ref$static2$showArro,
    _ref$static2$showRati = _ref$static2.showRating,
    showRating = _ref$static2$showRati === void 0 ? true : _ref$static2$showRati,
    _ref$static2$interval = _ref$static2.interval,
    interval = _ref$static2$interval === void 0 ? 5000 : _ref$static2$interval,
    _ref$static2$transiti = _ref$static2.transitionDuration,
    transitionDuration = _ref$static2$transiti === void 0 ? 400 : _ref$static2$transiti,
    _ref$static2$gutter = _ref$static2.gutter,
    gutter = _ref$static2$gutter === void 0 ? 2 : _ref$static2$gutter,
    _ref$static2$productT = _ref$static2.productTitleAs,
    productTitleAs = _ref$static2$productT === void 0 ? 'h2' : _ref$static2$productT,
    _ref$static2$imageAlt = _ref$static2.imageAltPrefix,
    imageAltPrefix = _ref$static2$imageAlt === void 0 ? '' : _ref$static2$imageAlt,
    _ref$static2$imgLazyL = _ref$static2.imgLazyLoading,
    imgLazyLoading = _ref$static2$imgLazyL === void 0 ? true : _ref$static2$imgLazyL,
    _ref$static2$cardType = _ref$static2.cardType,
    cardType = _ref$static2$cardType === void 0 ? 'vertical' : _ref$static2$cardType,
    _ref$static2$showBord = _ref$static2.showBorder,
    showBorder = _ref$static2$showBord === void 0 ? false : _ref$static2$showBord,
    _ref$static2$showOffe = _ref$static2.showOfferTimer,
    showOfferTimer = _ref$static2$showOffe === void 0 ? false : _ref$static2$showOffe,
    _ref$static2$showButt = _ref$static2.showButton,
    showButton = _ref$static2$showButt === void 0 ? false : _ref$static2$showButt,
    _ref$static2$buttonPr = _ref$static2.buttonProps,
    buttonProps = _ref$static2$buttonPr === void 0 ? {} : _ref$static2$buttonPr,
    _ref$static2$hideOrig = _ref$static2.hideOriginalPrice,
    hideOriginalPrice = _ref$static2$hideOrig === void 0 ? false : _ref$static2$hideOrig,
    staticProps = _objectWithoutProperties(_ref$static2, _excluded),
    structure = _ref.structure;
  var _useProductList = useProductList({
      data: data,
      "static": staticProps,
      structure: structure
    }),
    display = _useProductList.display,
    handleProductMouseDown = _useProductList.handleProductMouseDown,
    handleProductClick = _useProductList.handleProductClick,
    handleProductView = _useProductList.handleProductView,
    handleThumbnailClick = _useProductList.handleThumbnailClick,
    isEmptyList = _useProductList.isEmptyList,
    products = _useProductList.products;
  if (isEmptyList || !(products == null ? void 0 : products.length)) {
    return null;
  }
  return React.createElement(ProductCarouselModule, {
    products: products,
    displayMode: displayMode || display,
    onClick: handleProductClick,
    onMouseDown: handleProductMouseDown,
    onProductView: handleProductView,
    auto: auto,
    showControls: showControls,
    slidesPerView: slidesPerView,
    showPartialNextSlide: showPartialNextSlide,
    showArrowControls: showArrowControls,
    showRating: showRating,
    interval: interval,
    transitionDuration: transitionDuration,
    gutter: gutter,
    productTitleAs: productTitleAs,
    imageAltPrefix: imageAltPrefix,
    imgLazyLoading: imgLazyLoading,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    enableHover: enableHover,
    showInCashInfo: showInCashLabel,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    cardType: cardType,
    offerTimerProps: (structure == null ? void 0 : (_structure$theme = structure.theme) == null ? void 0 : _structure$theme.name) === 'magazineluiza-bf' ? offerTimerProps : undefined,
    showBorder: showBorder,
    showOfferTimer: showOfferTimer,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: hideOriginalPrice,
    hidePriceWhen: isServiceType,
    hideShippingTagWhen: isServiceType,
    isSellerPage: isSellerPage,
    isSlider: isSlider,
    onThumbnailClick: handleThumbnailClick,
    colorMinLength: colorMinLength,
    attributeStyle: attributeStyle
  });
};
process.env.NODE_ENV !== "production" ? ProductCarousel.propTypes = {
  data: shape({}),
  "static": shape({
    allowEmptyRating: bool,
    auto: bool,
    buttonProps: shape({}),
    cardType: string,
    colorMinLength: number,
    context: shape({}),
    displayMode: string,
    domain: string,
    enableHover: bool,
    gutter: number,
    hideOriginalPrice: bool,
    imageAltPrefix: string,
    imageHeight: number,
    imageWidth: number,
    imgLazyLoading: bool,
    inCashDescription: string,
    interval: number,
    isSellerPage: bool,
    isSlider: bool,
    origin: string,
    position: number,
    productTitleAs: string,
    showArrowControls: bool,
    showBorder: bool,
    showButton: bool,
    showControls: bool,
    showDiscount: bool,
    showDiscountOnlyCashInfo: bool,
    showInCashLabel: bool,
    showOfferTimer: bool,
    showPartialNextSlide: bool,
    showRating: bool,
    showWishBtn: bool,
    slidesPerView: number,
    spa: bool,
    transitionDuration: number,
    type: string
  }),
  structure: shape({})
} : void 0;
ProductCarousel.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
ProductCarousel.ssr = true;
ProductCarousel.displayName = 'ProductCarousel';
ProductCarousel.dataSource = {
  search: {
    query: 'SearchQuery'
  }
};
export default withLayoutProps(ProductCarousel);